<template>
  <!--下拉详情-->
  <div class="main">
    <section class="main-wrap">
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          公司名称：<span>{{ details.companyName }}</span>
        </el-col>
        <el-col :span="8" class="address">
          公司类型：<span>{{ details.companyTypeLabel }}</span>
        </el-col>
        <el-col :span="8" class="address">
          审核人：<span>{{ details.auditor }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          联系人：<span>{{ details.companyContact }}</span>
        </el-col>
        <el-col :span="8" class="address">
          联系电话：<span>{{ details.contactTel }}</span>
        </el-col>
        <el-col :span="8" class="address">
          支付方式：<span>{{ details.payType }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          本次赞助：<span>{{ details.newMoney }}<i v-if="details.newMoney==null">0</i>元</span>
        </el-col>
        <el-col :span="8" class="address">
          上次赞助：<span>{{ details.oldMoney }}<i v-if="details.oldMoney==null">0</i>元</span>
        </el-col>
        <el-col :span="8" class="address">
          赞助总额：<span>{{ details.moneyTotal }} <i v-if="details.moneyTotal==null">0</i>元</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="16" class="address">
          创建日期：<span>{{ details.createDate }}</span>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .main-wrap{
    padding: 25px 20px 0px 20px;
    border-top: 1px solid #DBDDE1;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    transition: all 0.8s ease-in-out;
    animation: show 0.8s ease-in-out;

    .main-item{
      font-size: 14px;
      padding-bottom: 25px;
      .item-remarks{
        color: #BE2316;
        span{
          color: #000;
          word-wrap:break-word;
        }
      }
    }
  }
</style>
